export default __webpack_public_path__ + "static/media/whyChooseUsIcon3.c5f9eec9.webp";